/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralSource } from './nonCadastralSource.model';


export interface NonCadastralLv { 
    cadastreName?: string;
    distinctChar?: string;
    districtName?: string;
    katuzeKod?: number;
    lv?: number;
    municipalityName?: string;
    regionName?: string;
    source?: NonCadastralSource;
}
export namespace NonCadastralLv {
}


